module.exports = __webpack_public_path__ + "static/images/styles/images/reserves/airstrike-toolbar.851409b2.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/reserves/airstrike-toolbar.png
// module id = 3697
// module chunks = 11